import { useState } from "react"

// Sichtbarkeitszustand der Vessel-Ansicht (Auge). Das markierte Vessel und
// die Layer-Selektion leben im Tree-Reducer, die Stammdaten im RouteStore.
export function useVesselViewState() {
  const [switchVesselFiltersActive, setSwitchVesselFiltersActive] =
    useState(false)

  return {
    switchVesselFiltersActive,
    setSwitchVesselFiltersActive,
  }
}
